import _ from "underscore";
import DisabledNodesParentNodeRenderer from "../tree/DisabledNodesParentNodeRenderer";

export default function ArchivedCustomersParentNodeRenderer(tree, selectorFilter, selectionHelper)
{
    DisabledNodesParentNodeRenderer.call(this, tree, selectorFilter, selectionHelper);
}

ArchivedCustomersParentNodeRenderer.prototype = _.create(DisabledNodesParentNodeRenderer.prototype, {
    labelMessageKey: function()
    {
        return "cp_selector.archived_customers_parent_node_label"
    },

    getNodeClasses: function(treeNode)
    {
        var classes = DisabledNodesParentNodeRenderer.prototype.getNodeClasses.call(this, treeNode);
        classes.push("archivedCustomersParent");
        return classes;
    }
});



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/customerProjectSelector/ArchivedCustomersParentNodeRenderer.js